import {axios} from "~/plugins/axios";

const getDefaultState_ByDays = () => {
  return {
    items: [],
  }
}
const state = getDefaultState_ByDays();

const getters = {
  complaintsReport: state => state.items,
}

const actions = {
  async loadQuestionnaires({commit}) {
    try {
      const response = await axios.get('/api/operator-quality-control/questionnaire-types')
        .catch(error => {console.error(error)})
      return response.data
    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },

  async loadQuestionnairesGraph({commit}, projectsIds) {
    try {
      let q = `questionnaires(projects: ${JSON.stringify(projectsIds) || '[]'}) {
        name
      }`
      const resp = await axios.post('/api/graphql', {query: `{${q}}`})
        .catch(error => {console.error(error)})
      return resp.data.data.questionnaires.map(el => el.name)
    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },

  async loadComplaintsReportItems({commit}, payload) {
    commit('shared/SET_LOADING', true, {root: true})
    try {
      let orderBy = {
        date: 'order_by: ',
        gate_project: 'order_by_project: ',
        operator: 'order_by_user: ',
      }
      let order = orderBy[payload.sort.by] + (payload.sort.desc ? '"desc"' : '"asc"')

      let q = `complaints(
        page: ${payload.page}
        limit: 25
        ${order}
        projects: ${JSON.stringify(payload.projects) || '[]'}
        ${payload.periodType}: ${JSON.stringify(payload.period)}
        users: ${JSON.stringify(payload.agents) || '[]'}
        authors: ${JSON.stringify(payload.authors) || '[]'}
        duration_range: [${payload.duration.from}, ${payload.duration.to}]
        type_ids: ${JSON.stringify(payload.types) || '[]'}
        ${payload.is_gpt ? 'is_gpt: true' : ''}
        ${payload.onlyUnread ? 'only_unread: true' : ''}
        ${payload.onlyMining ? 'only_mining: true' : ''}
        ${payload.onlyTransfered ? 'only_transfered: true' : ''}
        ${'isAuto' in payload ? `is_auto: ${payload.isAuto}` : ''}
        ${'isConfirmed' in payload ? `is_confirmed: ${payload.isConfirmed}` : ''}
        ${'isValid' in payload ? `is_valid: ${payload.isValid}` : ''}
        kln_range: [${payload.klnScore[0]}, ${payload.klnScore[1]}]
      ) {
        data {
          id
          uid
          call_date
          created_at
          mining_date
          mining_date_write
          source
          call_cards {
            form_id
            data
            form {
              title
            }
          }
          gate_project {
            name
          }
          type
          gate_user {
            full_name
          }
          sip
          criterias
          kln
          kln_color
          author
          comment
          complaint_delete
          complaint_update
          ai_analysis_status
          calibration_status
          calibration_comment
        }
        total
        per_page
        current_page
        last_page
      }`
      const resp = await axios.post('/api/graphql', {query: `{${q}}`})
        .catch(error => {console.error(error)})

      let meta = {
        total: resp.data.data?.complaints?.total,
        per_page: resp.data.data?.complaints?.per_page,
        current_page: resp.data.data?.complaints?.current_page,
        last_page: resp.data.data?.complaints?.last_page,
      }
      this.dispatch('shared/setMeta', meta)

      commit('shared/SET_LOADING', false, {root: true})
      commit('SET_ITEMS', resp.data.data.complaints)
      return resp.data.data.complaints

    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})
      commit('shared/SET_LOADING', false, {root: true})

      throw err
    }
  },

  async loadWiretappingTotalDuration({commit}, payload) {
    try {
      return await axios.post('/api/reports/complaints/total-duration', payload)
    } catch (error) {
      commit('shared/SET_ERROR', error.response.data, {root: true})
      throw error
    }
  },

  async deleteComplaint({commit}, complaintId) {
    axios.delete(`/api/complaints/${complaintId}`)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
      });
  },

  async updateComplaint({commit}, payload) {
    axios.put(`/api/complaints/${payload.id}`, payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
      });
  },

  async setMiningDate({commit}, payload) {
    const complaintId = payload.complaintId
    axios.post(`/api/complaints/${complaintId}/set-mining-date`, payload)
      .then(response => {
        commit('shared/SET_SUCCESS', {message: response.data.message}, {root: true});
      })
      .catch(error => {
        if (error.response) {
          commit('shared/SET_ERROR', error.response.data, {root: true});
        } else if (error.request) {
          commit('shared/SET_ERROR', error.request, {root: true});
        } else {
          commit('shared/SET_ERROR', error.message, {root: true});
        }
      });
  },
}

const mutations = {
  SET_ITEMS(state, items) {
    state.items = items;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
